<ejs-sidebar id="default-sidebar" width="240" enableDock="true" dockSize="20" [enableGestures]="false">
  <div class="version-wrapper">
    <span class="e-icons sidebar-pin" [ngClass]="{'icon-pin': !isPinned, 'icon-pin--filled': isPinned}" (click)="onPinToggle()" [hidden]="!isSidebarOpen"></span>
    <app-navigation [hidden]="!isSidebarOpen"></app-navigation>
    <div class="spacer"></div>
    <div class="version" [hidden]="!isSidebarOpen"><div>{{version}}</div></div>
  </div>
</ejs-sidebar>
<div class="main-container">
  <app-spinner></app-spinner>
  <router-outlet></router-outlet>
</div>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-modal></app-modal>
